import * as yup from "yup";
import {INVALIDATION_TIP, REGEX} from "../../../const/validation";

export const registerSchema = yup.object().shape({
  name: yup
    .string()
    .required(INVALIDATION_TIP.FIELD_REQUIRED)
    .matches(
      REGEX.FULL_NAME_REGEX,
      INVALIDATION_TIP.INCORRECT_NAME,
    )
    .min(2, INVALIDATION_TIP.MIN_LENGTH_NAME),
  company: yup.string(),
  email: yup
    .string()
    .required(INVALIDATION_TIP.FIELD_REQUIRED)
    .matches(
      REGEX.VALID_EMAIL,
      INVALIDATION_TIP.INCORRECT_EMAIL,
    ),
  password: yup
    .string()
    .required(INVALIDATION_TIP.FIELD_REQUIRED)
    .min(8, INVALIDATION_TIP.MIN_LENGTH_PASSWORD)
    .max(16, INVALIDATION_TIP.MAX_LENGTH_PASSWORD )
    .matches(
      REGEX.VALID_PASSWORD,
      INVALIDATION_TIP.INCORRECT_PASSWORD,
    ),
  password2: yup
    .string()
    .oneOf([yup.ref("password"), null], INVALIDATION_TIP.MATCHES_PASSWORD)
    .required(INVALIDATION_TIP.FIELD_REQUIRED),
});
